export enum GridTypes {
    ZARA_STUDIO = 1,
    GRID_4 = 2,
    GRID_16 = 3,
    RELATEDS = 4,
    SEARCH = 5,
}

export const gridTypeToNumberOfProducts: Record<GridTypes, number> = {
    [GridTypes.ZARA_STUDIO]: 2,
    [GridTypes.GRID_4]: 4,
    [GridTypes.GRID_16]: 12,
    [GridTypes.RELATEDS]: 5,
    [GridTypes.SEARCH]: 6,
};

export const GridTypeValue = 'GRIPTYPE';

export type GridType = 1 | 2 | 3 | 4 | 5;
